// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import moduleReducer from '../slices/moduleSlice';
import roleReducuer from '../slices/roleSlice';
import companyReducuer from '../slices/companySlice';
import userReducuer from '../slices/userSlice';
import permissionReducer from '../slices/permissionSlice';
import clientReducer from '../slices/toneWebSlice';
import actionReducer from '../slices/actionSlice';
import campaignMediaReducer from '../slices/campaignSlice';
import demoMediaReducer from '../slices/demoMediaSlice';
import locationReducer from '../slices/locationSlice';
import userRequestReducer from '../slices/userRequestSlice';
import dashboardSliceReducer from '../slices/dashboardSlice';
import tenantReducer from '../slices/tenantSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    module: moduleReducer,
    role: roleReducuer,
    company: companyReducuer,
    user: userReducuer,
    permission: permissionReducer,
    client: clientReducer,
    actions: actionReducer,
    campaignMedia: campaignMediaReducer,
    demoMedia: demoMediaReducer,
    location: locationReducer,
    userRequest: userRequestReducer,
    dashboard: dashboardSliceReducer,
    tenant: tenantReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
